
































import { defineComponent } from '@vue/composition-api';

const name = 'ttam-creative-deffered-deep-link-dpa-product-link';

export default defineComponent({
  name,
  props: {
    isValid: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const goToProductSet = () => {
      emit('link-to-product-set');
    };
    const validDpaUrl = () => {
      emit('refresh');
    };
    return {
      name,
      goToProductSet,
      validDpaUrl,
    };
  },
});
